"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uniq_1 = __importDefault(require("lodash/uniq"));
var normalizr_1 = require("normalizr");
var createUnionSchema_1 = __importStar(require("./createUnionSchema"));
/*
    Step 1: Create an entity schema for each individual entity
    Step 2. Create relationships TO each of these entities.
    Step 3. Define the entities in step 1. with the relationships in step 2
*/
/*
    Note: assumes entity name is the same as its index
    @param Exceptions: list of entities we DON'T want to denormalize
*/
var printError = console.log.bind(console);
var buildSchemaFromViewConfig = function (viewConfig, exceptions, errorReporter) {
    if (exceptions === void 0) { exceptions = []; }
    if (errorReporter === void 0) { errorReporter = printError; }
    var entitySchemas = {};
    var relationshipSchemas = {};
    Object.values(viewConfig.entities).forEach(function (e) {
        entitySchemas[e.name] = new normalizr_1.schema.Entity(e.name);
    });
    var unionSchema = (0, createUnionSchema_1.default)(Object.values(entitySchemas));
    entitySchemas[createUnionSchema_1.WILDCARD_ENTITY] = unionSchema;
    // now entitySchemas is loaded with each of our entities.
    // now iterate over all relationships
    var fields = [].concat.apply(
    // 1 dimensional array of all fields
    [], Object.values(viewConfig.entities).map(function (e) { return Object.values(e.fields); }));
    // all unique relationships in form REL_TYPE:entity
    var relationships = (0, uniq_1.default)(fields
        .filter(function (f) {
        return f.dataType === 'REFONE' ||
            f.dataType === 'REFONE_JOIN' ||
            f.dataType === 'REFMANY' ||
            f.dataType === 'REFMANYMANY' ||
            f.dataType === 'REFMANY_JOIN' ||
            f.dataType === 'VALUESET' ||
            f.dataType === 'VALUESETMANY';
    })
        .map(function (f) { return "".concat(f.dataType, ":").concat(f.relatedEntity); }));
    // add all arrays to relationshipSchemas
    relationships
        .filter(function (f) { return f.startsWith('REFMANY') || f.startsWith('VALUESETMANY'); })
        .forEach(function (ref) {
        var schemaName = ref.split(':')[1];
        var entitySchema = entitySchemas[schemaName];
        relationshipSchemas[ref] = new normalizr_1.schema.Array(entitySchema);
    });
    // now for each entitySchema, defined in terms of relationships
    Object.entries(entitySchemas)
        .filter(function (_a) {
        var key = _a[0], entitySchema = _a[1];
        return key !== createUnionSchema_1.WILDCARD_ENTITY;
    })
        .forEach(function (_a) {
        var key = _a[0], entitySchema = _a[1];
        var definition = {};
        Object.values(viewConfig.entities[key].fields)
            // .filter(f => f.name !== 'xxxxx' && f.name !== 'mergeRecords')
            .forEach(function (f) {
            if (f.dataType === 'REFONE' || f.dataType === 'REFONEJOIN' || f.dataType === 'VALUESET') {
                if (f.relatedEntity) {
                    definition[f.name] = entitySchemas[f.relatedEntity];
                }
                else {
                    errorReporter('expected relatedEntity in REFONE/REFONE_JOIN/VALUESET field ' + JSON.stringify(f));
                }
            }
            if (f.dataType === 'REFMANY' ||
                f.dataType === 'REFMANYMANY' ||
                f.dataType === 'REFMANYJOIN' ||
                f.dataType === 'VALUESETMANY') {
                if (f.relatedEntity) {
                    definition[f.name] = relationshipSchemas["".concat(f.dataType, ":").concat(f.relatedEntity)];
                }
                else {
                    errorReporter('expected relatedEntity in REFMANY/REFMANY_JOIN/VALUESETMANY field ' +
                        JSON.stringify(f));
                }
            }
        });
        if (exceptions.indexOf(key) === -1) {
            // allow exceptions.
            entitySchemas[key].define(definition);
        }
    });
    delete entitySchemas[createUnionSchema_1.WILDCARD_ENTITY];
    return entitySchemas;
};
exports.default = buildSchemaFromViewConfig;
//# sourceMappingURL=buildSchemaFromViewConfig.js.map